import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getAccessRights } from '../../Services/Account';


export const fetchAccessData = createAsyncThunk<any, void>(
    "AccessRight/fetchData",
    async (): Promise<any> => {
        const data = await getAccessRights();
        return {
            accessValue: data
        };
    }
);

const AccessRightSlice = createSlice({
    name: 'AccessRight',
    initialState: {
        accessValue: {}
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAccessData.fulfilled, (state, action) => {
            state.accessValue = action.payload.accessValue;
        });
    },
});

export default AccessRightSlice.reducer;
